<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fKvS4g/tc-custom/9781632658937.jpg?1726444229018" alt="This image is the cover for the book Encounter in the Desert"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Encounter in the Desert
      </h1>
      <p class="bookDescription body article font2">
        <b>From a former army officer and author of <i>UFOS and the Deep State</i>, a new examination of a UFO sighting in a New Mexican arroyo.</b><br/><br/>The UFO landing at Socorro has been wrapped in controversy almost from the moment that police officer Lonnie Zamora watched a craft descend and land. Zamora saw alien beings near the craft and a symbol on its side but was told that he shouldn’t mention either. <i>Encounter in the Desert</i> reveals—for the first time—exactly what he saw in that arroyo in 1964 and what an examination of the landing revealed to investigators. Socorro wasn’t a stand-alone case. Other sightings, some of them nearly as spectacular as Zamora’s, were reported at the time. A study of the Air Force investigation of this case reveals an effort, at first, to learn the truth that mutated into a clever attempt to hide the information from the public. <i>Encounter in the Desert</i> reveals all this and much more, including:The first new, in-depth look at the Zamora UFO landing in more than three decades.Other reports of alien creatures sighted around the country at the same time.An examination of the physical evidence found on the landing site.The revelation that there were other witnesses to the craft and the landing.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Randle
      </h2>
      
      <p class="authorDescription body article">Kevin D. Randle is a retired Army lieutenant colonel who served as a helicopter pilot in Vietnam and an intelligence officer in Iraq. He studied anthropology and journalism at the University of Iowa and holds advanced degrees from the American Military University and California Coast University. He has been studying UFOs for 50 years and has published dozens of books about the subject, including Crash: When UFOs Fall from the Sky. He hosts a radio show on the X-Zone Broadcast Network and a blog, A Different Perspective. He has appeared on dozens of television and radio shows, including The Today Show, Good Morning America, and many others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Page Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6722edbe